import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBox, DBIntField, DBTextField } from '_components';
import { PatientCareCenterNoteSection } from '../Section';
import styles from './Common.module.css';

class PatientCareCenterNoteAssessmentOrthosis extends React.Component {


    handleOtherClick(val) {
        if (val === false && this.props.otherText !== null) {
            this.props.clearField(this.props.noteId, 'PTASSESSMENT', 'ASNO', this.props.asno, 'ASORTHTYPEOTHERTXT');
        }
    }

    render() {
        if (this.props.noteType !== 1) {
            return (<span />);
        }
        return (
            <PatientCareCenterNoteSection id='assessment_orthosis' name='Orthosis' level={1}>
                <div className={styles.row}>
                    <label className={styles.orthosis_label}>This orthosis should be worn as prescribed below:</label>
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <span className={styles.worn_checkbox}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHWORNPERDAY'}
                            label={''}
                        // className={styles.worn_checkbox}
                        />
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHWORNPERDAYTIMES'}
                            min={0}
                            className={styles.small_textfield}
                        />
                        <label className={styles.label_nopad}>&nbsp;times per day for&nbsp;</label>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHWORNPERDAYMINS'}
                            min={0}
                            className={styles.small_textfield}
                        />
                        <label className={styles.label_nopad}>&nbsp;minute sessions</label>
                    </span>
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNALLTIMES'}
                        label={'At all times'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNNIGHT'}
                        label={'At night'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNASNEEDED'}
                        label={'Wear as needed'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNATWORK'}
                        label={'At work'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNTOENHANCE'}
                        label={'To enhance occupational performance'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNREMEXER'}
                        label={'Remove for exercises'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNREMDRESSING'}
                        label={'Remove for dressing changes'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHWORNREMHYGIENE'}
                        label={'Remove for hygiene'}
                        className={styles.worn_checkbox}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHHOMEPROG'}
                        label={'Orthosis Home Program was established.'}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHPRECAUTIONS'}
                        label={'Orthosis precautions were reviewed.'}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHDONDOFF'}
                        label={'Patient demonstrated donning/doffing of orthosis.'}
                    />
                </div>
                <div className={styles.orthosis_checkbox_row}>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field={'ASORTHCLEAN'}
                        label={'Cleaning and maintenance education were provided.'}
                    />
                </div>
                <div className={styles.row}>
                    <label className={styles.orthosis_label}>The custom orthosis was fabricated as requested from a flat sheet of low-temperature thermoplastic
                    material. The material was custom molded on the patient according to individual heat tolerance to
                    provide the following orthosis in compliance with the physician's prescription.</label>
                </div>
                <div className={styles.two_column_wrapper}>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPEUPARM'}
                            label={'Upper arm based'}
                            className={styles.checkbox_col1}
                        />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPEULNAR'}
                            label={'Ulnar based'}
                            className={styles.checkbox_col2}
                        />
                    </div>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPEFOREARM'}
                            label={'Forearm based'}
                            className={styles.checkbox_col1}
                        />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPEDORSAL'}
                            label={'Dorsal based'}
                            className={styles.checkbox_col2}
                        />
                    </div>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPEHAND'}
                            label={'Hand based'}
                            className={styles.checkbox_col1}
                        />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPEVOLAR'}
                            label={'Volar based'}
                            className={styles.checkbox_col2}
                        />
                    </div>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPEFINGER'}
                            label={'Finger based'}
                            className={styles.checkbox_col1}
                        />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPECIRCUM'}
                            label={'Circumferential'}
                            className={styles.checkbox_col2}
                        />
                    </div>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHTYPERADIAL'}
                            label={'Radial based'}
                            className={styles.checkbox_col1}
                        />
                        <span className={styles.checkbox_col2}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.asno}
                                field={'ASORTHTYPEOTHER'}
                                label={'Other'}
                                // className={styles.checkbox_col2}
                                onClick={(event) => this.handleOtherClick(event)}
                            />
                            {this.props.otherSelected &&
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTASSESSMENT'
                                    entityKeyColumn='ASNO'
                                    entityKeyValue={this.props.asno}
                                    field={'ASORTHTYPEOTHERTXT'}
                                    className={styles.textfield}
                                />
                            }
                        </span>
                    </div>
                </div>
                <div className={styles.row}>
                    <label className={styles.orthosis_label}>In order to secure this orthosis, velcro or soft strapping were added at the following locations:</label>
                </div>
                <div className={styles.two_column_wrapper}>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHSTRAPUPARM'}
                            label={'Upper arm based'}
                            className={styles.checkbox_col1}
                        />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHSTRAPHAND'}
                            label={'Hand'}
                            className={styles.checkbox_col2}
                        />
                    </div>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHSTRAPELBOW'}
                            label={'Elbow'}
                            className={styles.checkbox_col1}
                        />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHSTRAPFINGER'}
                            label={'Finger'}
                            className={styles.checkbox_col2}
                        />
                    </div>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHSTRAPFOREARM'}
                            label={'Forearm'}
                            className={styles.checkbox_col1}
                        />
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHSTRAPTHUMB'}
                            label={'Thumb'}
                            className={styles.checkbox_col2}
                        />
                    </div>
                    <div className={styles.orthosis_checkbox_row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field={'ASORTHSTRAPWRIST'}
                            label={'Wrist'}
                            className={styles.checkbox_col1}
                        />
                    </div>
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));

    let otherText = state.entities.notes.PTASSESSMENT[asno].ASORTHTYPEOTHERTXT;
    let otherSelected = state.entities.notes.PTASSESSMENT[asno].ASORTHTYPEOTHER;

    return {
        noteId,
        noteType,
        asno,
        otherText,
        otherSelected
    };
}

const connectedPatientCareCenterNoteAssessmentOrthosis = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteAssessmentOrthosis);
export { connectedPatientCareCenterNoteAssessmentOrthosis as PatientCareCenterNoteAssessmentOrthosis };

